import { render } from "./QC1AreaRetention.vue?vue&type=template&id=152e4d1d"
import script from "./QC1AreaRetention.vue?vue&type=script&lang=js"
export * from "./QC1AreaRetention.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/QCCharts/microgen/QC1AreaRetention.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "152e4d1d"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('152e4d1d', __exports__)) {
    console.log('reload')
    api.reload('152e4d1d', __exports__)
  }
  
  module.hot.accept("./QC1AreaRetention.vue?vue&type=template&id=152e4d1d", () => {
    console.log('re-render')
    api.rerender('152e4d1d', render)
  })

}


export default __exports__